<script setup lang="ts">
import SignupForm from "@/components/SignupForm/SignupForm.vue"

definePage({
  meta: {
    requiresAuth: false,
  },
})
</script>

<template>
  <SignupForm />
</template>
